import { makeStyles, Theme } from "@material-ui/core";

const drawerWidth = 270;

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    backgroundColor: "#F8FAFC",
  },
  toolbar: {
    paddingLeft: 24,
    paddingRight: 28,
    minHeight: 70,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  menu: {
    "& .MuiPaper-root": {
      borderRadius: "16px",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 10px 30px -5px rgba(15, 23, 42, 0.15)",
      border: "1px solid #E2E8F0",
      overflowX: "hidden",
      overflowY: "auto",
      padding: 8,
      width: 220,
    },
    "& .MuiMenuItem-root": {
      borderRadius: 10,
      fontSize: "0.875rem",
      fontWeight: 600,
      color: "#334155",
      padding: "10px 16px",
      margin: "2px 0",
      gap: 10,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#F1F5F9",
        color: "#4F46E5",
      },
    },
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 20px",
    minHeight: 70,
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    cursor: "pointer",
  },
  logoText: {
    fontWeight: 900,
    fontSize: "1.15rem",
    background: "linear-gradient(135deg, #FFFFFF 0%, #CBD5E1 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    letterSpacing: "-0.02em",
  },
  logoBadge: {
    fontSize: "0.65rem",
    fontWeight: 800,
    backgroundColor: "rgba(99, 102, 241, 0.2)",
    color: "#818CF8",
    padding: "2px 6px",
    borderRadius: 6,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    border: "1px solid rgba(129, 140, 248, 0.3)",
  },
  usernameGroup: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    marginRight: 12,
  },
  username: {
    fontSize: "0.875rem",
    fontWeight: 800,
    color: "#0F172A",
    lineHeight: 1.2,
  },
  userRole: {
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#64748B",
    marginTop: 2,
  },
  profileWidget: {
    display: "flex",
    alignItems: "center",
    padding: "4px 10px 4px 14px",
    borderRadius: 14,
    backgroundColor: "#F8FAFC",
    border: "1px solid #E2E8F0",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#F1F5F9",
      borderColor: "#CBD5E1",
    },
  },
  icon__profile: {
    padding: 0,
    cursor: "pointer",
  },
  avatar: {
    width: 38,
    height: 38,
    borderRadius: "50%",
    border: "2px solid #6366F1",
    boxShadow: "0 2px 8px rgba(99, 102, 241, 0.25)",
  },
  appBar: {
    backgroundColor: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(16px)",
    WebkitBackdropFilter: "blur(16px)",
    boxShadow: "0 4px 20px -2px rgba(0, 0, 0, 0.04)",
    borderBottom: "1px solid rgba(226, 232, 240, 0.8)",
    color: "#0F172A",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 16,
    color: "#475569",
    backgroundColor: "#F1F5F9",
    borderRadius: 10,
    padding: 8,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#E2E8F0",
      color: "#0F172A",
    },
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
    cursor: "pointer",
  },
  logo: {
    objectFit: "cover",
    cursor: "pointer",
    height: 36,
    width: 36,
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  },
  icon__prev: {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
    color: "#F8FAFC",
    width: 32,
    height: 32,
    borderRadius: 10,
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.16)",
      color: "#FFFFFF",
    },
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    backgroundColor: "#0F172A",
    color: "#F8FAFC",
    borderRight: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "4px 0 24px rgba(0, 0, 0, 0.12)",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create(["width", "visibility"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: 0,
    borderRight: "none !important",
    visibility: "hidden",
    boxShadow: "none !important",
    [theme.breakpoints?.up("sm")]: {
      width: 0,
    },
  },
  drawerPaperMobile: {
    width: drawerWidth,
    height: "100%",
    backgroundColor: "#0F172A",
    color: "#F8FAFC",
  },
  appBarSpacer: {
    minHeight: 70,
  },
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    backgroundColor: "#F8FAFC",
  },
  container: {
    padding: "24px 28px",
    [theme.breakpoints?.up("md")]: {
      minWidth: 800,
    },
    maxWidth: 1600,
    margin: "0 auto",
    overflow: "hidden",
    [theme.breakpoints?.down("sm")]: {
      padding: "10px 8px",
    },
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default useStyles;
